import React from "react";
import { useTranslation } from "react-i18next";

const CTA = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <section
      className="py-5 bg-primary-custom text-white"
      dir={languageDirection}
    >
      <div className="container py-4">
        <div className="row align-items-center">
          <div className="col-lg-7 mb-4 mb-lg-0">
            <h2 className="fw-bold mb-3">{t("cta_title")}</h2>
            <p className="lead mb-0">{t("cta_description")}</p>
          </div>
          <div className="col-lg-5 text-lg-end">
            <div className="d-flex flex-column flex-md-row justify-content-lg-end align-items-center gap-2">
              <a href="/speakers" className="btn btn-outline-warning btn-lg">
                {t("cta_explore_speakers")}
              </a>
              <a href="/signup" className="btn btn-outline-light btn-lg">
                {t("cta_join_as_speaker")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
